import React from 'react';
import { JoinButton, useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { useStaticSplashPage } from 'src/client/helpers/useFeatureFlags';
import { PillButton } from 'src/client/pages/StaticSplash/styles';
import { useSelector } from 'src/client/redux';
import styled from 'styled-components/macro';
import { HEADER_BAR } from 'src/client/constants/joinCampaigns';

export const JoinButtons = () => {
  const user = useSelector((state) => state.auth.user);
  const showFreeMemberJoinButton = user && !user.validSubscription;

  return (
    <>
      {showFreeMemberJoinButton ? (
        <StyledJoinButton className="btn btn-primary join-btn" data-value="regular" campaign={HEADER_BAR}>
          JOIN NOW
        </StyledJoinButton>
      ) : (
        <JoinButtonSwitcher campaign={HEADER_BAR}>Get Started</JoinButtonSwitcher>
      )}
    </>
  );
};

const JoinButtonSwitcher: React.FC<{ campaign: string }> = (props) => {
  const { campaign, children } = props;
  const [href] = useJoinUrl({ campaign });
  const { isStaticSplashPage } = useStaticSplashPage();

  if (isStaticSplashPage) {
    return (
      <JoinPillButton as="a" href={href} data-value="regular" data-tagmanager-event="join_cta">
        {children}
      </JoinPillButton>
    );
  }

  return (
    <StyledJoinButton
      campaign={campaign}
      className="btn btn-primary join-btn"
      data-value="regular"
      data-tagmanager-event="join_cta"
    >
      {children}
    </StyledJoinButton>
  );
};

const StyledJoinButton = styled(JoinButton)`
  && {
    border-radius: 2px;
    padding: 8px 11px;
    text-transform: uppercase;
    background: ${(props) => props.theme.headerBarPrimary3};
    color: ${(props) => props.theme.primaryBtn1Text};
    min-height: auto;
    white-space: nowrap;
    margin: 0 5px;

    @media ${TABLET_PORTRAIT} {
      margin: 0 10px;
      padding: 10px 20px;
    }

    &:hover {
      background: ${(props) => props.theme.headerBarPrimary3};
      color: ${(props) => props.theme.primaryBtn1Text};
      opacity: 0.9;
    }
  }
`;

const JoinPillButton = styled(PillButton)`
  && {
    background-color: var(--brand-color);
    color: #000 !important;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    min-height: auto;
    white-space: nowrap;
    margin: 0 5px;

    @media ${TABLET_PORTRAIT} {
      margin: 0 10px;
    }
  }
`;
